'use client';

import AppLayout from '@/components/AppLayout';
import NotificationsScreen from './components/NotificationsScreen';

export default function NotificationsPage() {
  return (
    <AppLayout>
      <NotificationsScreen />
    </AppLayout>
  );
}
